import { AuditLogTable } from 'src/components/molecules';
import { AuditEntryType, useGetUserRolesAuditEntriesQuery } from 'src/graphql';
import { formatDateTime } from 'src/utils/commonFunctions';

interface Props {
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
}

export const UserRoleAuditLogModal = ({ isOpen, setIsOpen }: Props) => {
  // Note: useGetUserRolesAuditEntriesQuery hook is generated by running: cd react-ts && yarn generate
  const { data } = useGetUserRolesAuditEntriesQuery();

  const columns = [
    { label: 'User' },
    { label: 'Event' },
    { label: 'Role Changed' },
    { label: 'Changed By' },
    { label: 'Timestamp' },
  ];

  const tableDataCallback = (entry: AuditEntryType) => {
    const entryData = entry.data as {
      user?: string;
      event?: string;
      roleChanged?: string;
      changedBy?: string;
    };

    return {
      cellData: [
        entryData.user || '-',
        entryData.event || '-',
        entryData.roleChanged || '-',
        entryData.changedBy || '-',
        entry.createdAt ? formatDateTime(new Date(entry.createdAt)) : '-',
      ],
      row: entry.id?.toString() || '',
    };
  };

  return (
    <AuditLogTable
      auditLogEntries={(data?.userRolesAuditEntries as AuditEntryType[]) ?? []}
      isOpen={isOpen}
      setIsOpen={setIsOpen}
      columns={columns}
      tableDataCallback={tableDataCallback}
      emptyText="No user role audit log entries."
    />
  );
};
